import type { SurveyModel, TextMarkdownEvent } from "survey-core";
import type { SurveyCreatorModel } from "survey-creator-core";

export const onTextMarkdownApplyHtmlToSurveyContents = ({
  creator,
  surveyModel,
}: {
  creator?: SurveyCreatorModel;
  surveyModel?: SurveyModel;
}) => {
  if (!creator && !surveyModel) {
    throw new Error("creator or surveyModel is required");
  }
  if (creator) {
    creator.survey.onTextMarkdown.add(applyHtmlToSurveyContents);
    creator.onSurveyInstanceCreated.add((_, options) => {
      if (options.area === "designer-tab" || options.area === "preview-tab") {
        options.survey.onTextMarkdown.add(applyHtmlToSurveyContents);
      }
    });
  }
  if (surveyModel) {
    surveyModel.onTextMarkdown.add(applyHtmlToSurveyContents);
  }
};

const applyHtmlToSurveyContents = (
  sender: SurveyModel,
  options: TextMarkdownEvent,
) => {
  // Store HTML in the question for the custom React component to render
  options.html = options.text;
};
